<div id="gallery-carousel" class="carousel slide gallery-carousel" data-ride="carousel">

    <div class="carousel-inner" role="listbox">
        <div class="item" ng-repeat="item in ::ctrl.items track by $index" ng-class="{ 'active': $first }">
            <img class="gallery-carousel-item-image" ng-src="{{::item}}" alt="shop">
        </div>
    </div>

    <a class="left carousel-control"
       href="#gallery-carousel"
       role="button"
       data-slide="prev"
       ng-if="ctrl.items.length > 1">
        <span class="gallery-carousel-left-icon" aria-hidden="true"></span>
    </a>

    <a class="right carousel-control"
       href="#gallery-carousel"
       role="button"
       data-slide="next"
       ng-if="ctrl.items.length > 1">
        <span class="gallery-carousel-right-icon" aria-hidden="true"></span>
    </a>
</div>